import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TenantContainerModel} from '../../../../../models/aggregates/tenant';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../shared';
import {PasswordPolicyContainerModel} from '../../../../../models/aggregates/password-policy';

@Injectable({
  providedIn: 'root'
})
export class PasswordPolicyService extends BaseApiTemplateService<PasswordPolicyContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'password-policy-lines';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'password-policy-lines';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'password-policy-lines';
    this.httpClient = http;
  }

  getPasswordExpiration(appletCode: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/password-expiration/' + appletCode;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

}
